import script from "./ProgressTx.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressTx.vue?vue&type=script&setup=true&lang=js"

import "./ProgressTx.vue?vue&type=style&index=0&id=40061286&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40061286"]])

export default __exports__